import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  defaultUiContextState,
  IUiContextState,
} from '../models/ui-context-state.model';
import { UiContextActions } from './ui-context.actions';

@State<IUiContextState>({
  name: 'uicontext',
  defaults: defaultUiContextState,
})
@Injectable()
export class UiContextState {
  @Action(UiContextActions.ToggleSendEmailForm)
  toggleEmailForm(ctx: StateContext<IUiContextState>): void {
    const state = ctx.getState();
    ctx.patchState({
      sendEmailFormVisible: !state.sendEmailFormVisible,
      emailSuccessVisible: false,
    });
  }

  @Action(UiContextActions.HideSendEmailForm)
  hideEmailForm(ctx: StateContext<IUiContextState>): void {
    ctx.patchState({ sendEmailFormVisible: false, emailSuccessVisible: false });
  }

  @Action(UiContextActions.ShowEmailSentSuccessful)
  showEmailSuccessful(ctx: StateContext<IUiContextState>): void {
    ctx.patchState({ emailSuccessVisible: true });
  }

  @Action(UiContextActions.SendAnotherEmail)
  sendAnotherEmail(ctx: StateContext<IUiContextState>): void {
    ctx.patchState({ emailSuccessVisible: false });
  }

  @Action(UiContextActions.PageChanged)
  pageChanged(ctx: StateContext<IUiContextState>): void {
    const { emailSuccessVisible, showPromoCodeForm } = ctx.getState();
    if (emailSuccessVisible) {
      ctx.patchState({
        emailSuccessVisible: false,
        sendEmailFormVisible: false,
      });
    }

    if (showPromoCodeForm) {
      ctx.patchState({
        showPromoCodeFailure: false,
        showPromoCodeForm: false,
        showPromoCodeSuccess: false,
      });
    }
  }

  @Action(UiContextActions.ShowSpecifiedItem)
  showSpecifiedItem(
    ctx: StateContext<IUiContextState>,
    { item }: UiContextActions.ShowSpecifiedItem
  ): void {
    ctx.patchState({ specifiedItemTypeId: item.specifiedItemTypeId });
  }

  @Action(UiContextActions.ToggleSpecifiedItem)
  toggleSpecifiedItem(
    ctx: StateContext<IUiContextState>,
    { item }: UiContextActions.ToggleSpecifiedItem
  ): void {
    const { specifiedItemTypeId: selected } = ctx.getState();
    ctx.patchState({
      specifiedItemTypeId:
        selected === item.specifiedItemTypeId
          ? undefined
          : item.specifiedItemTypeId,
    });
  }

  @Action(UiContextActions.ResetSpecifiedItem)
  resetSpecifiedItem(ctx: StateContext<IUiContextState>): void {
    ctx.patchState({ specifiedItemTypeId: undefined });
  }

  @Action(UiContextActions.TogglePromoCodeForm)
  togglePromoCodeForm(ctx: StateContext<IUiContextState>): void {
    const state = ctx.getState();
    ctx.patchState({
      showPromoCodeForm: !state.showPromoCodeForm,
      showPromoCodeSuccess: false,
      showPromoCodeFailure: false,
    });
  }

  @Action(UiContextActions.TogglePromoCodeSuccess)
  togglePromoCodeSuccess(
    ctx: StateContext<IUiContextState>,
    { display }: UiContextActions.TogglePromoCodeSuccess
  ): void {
    const state = ctx.getState();
    let newValue = !state.showPromoCodeFailure;
    if (display != null) {
      newValue = display;
    }
    ctx.patchState({ showPromoCodeSuccess: newValue });
  }

  @Action(UiContextActions.TogglePromoCodeFailure)
  togglePromoCodeFailure(
    ctx: StateContext<IUiContextState>,
    { display }: UiContextActions.TogglePromoCodeFailure
  ): void {
    const state = ctx.getState();
    let newValue = !state.showPromoCodeFailure;
    if (display != null) {
      newValue = display;
    }
    ctx.patchState({ showPromoCodeFailure: newValue });
  }

  @Action(UiContextActions.SetQqcAlertMessage)
  setQqcAlertMessage(
    ctx: StateContext<IUiContextState>,
    { alertMessage }: UiContextActions.SetQqcAlertMessage
  ): void {
    ctx.patchState({ qqcAlertMessage: alertMessage });
  }

  @Action(UiContextActions.ResetQqcAlertMessage)
  resetQqcAlertMessage(ctx: StateContext<IUiContextState>): void {
    ctx.patchState({ qqcAlertMessage: undefined });
  }

  @Action(UiContextActions.SetTravellerAgeSelection)
  setTravellerAgeSelection(
    ctx: StateContext<IUiContextState>,
    { radioId }: UiContextActions.SetTravellerAgeSelection
  ) {
    ctx.patchState({ travellerAgeSelection: radioId });
  }
}
